module.exports = __webpack_public_path__ + "images/kawasaki22449ec41f85fe55de34f227db73cfed.png";